import React, { useState } from 'react';
import { StringParam, useQueryParam } from 'next-query-params';

import { makeStyles } from '@material-ui/core/styles';

import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

import NotesCard from '../../shared/Notes';

const NotesIcon = '/book/icons/adminNotes/notes.svg';

const initialNotesTemplate = `Move Day Notes:

Specialty Items such as pianos, safes, exercise equipment (Ex. 1 upright piano and 1 treadmill):

Drive Time in Minutes (Ex. 20):

Parking Instructions (Eg. park at loading dock):

Disassembly Items and Quantity (Ex. 2 chairs and 3 beds):

Assembly Items and Quantity (Ex. 2 chairs and 3 beds):

Other special instructions (Ex. check in with apartment office before heading to dock): 
`;

const useStyles = makeStyles(theme => ({
  buttonRoot: {
    padding: 0,
    [theme.breakpoints.up('md')]: {
      padding: 12,
    },
  },
}));

const Notes = () => {
  const classes = useStyles();

  const [notes, setNotes] = useQueryParam('notes', StringParam);
  const [tempNotes, setTempNotes] = useState(notes || initialNotesTemplate);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setNotes(tempNotes);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box>
      <Box position="fixed" bottom="110px" right="0" zIndex={10}>
        <IconButton classes={{ root: classes.buttonRoot }} onClick={handleClick}>
          <img src={NotesIcon} alt="notes icon" />
        </IconButton>
      </Box>
      <Popover
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <NotesCard notes={tempNotes} setNotes={setTempNotes} />
      </Popover>
    </Box>
  );
};

export default Notes;
